import { Outlet } from "react-router-dom";
import { useState } from "react";
import { Page } from "../../components/Page";
import {
  ContentWrapper,
  SidebarWrapper,
  Backdrop,
  MainContent,
} from "../../components/LayoutComponents";
import { AppNavbar } from "../components/AppNavbar";
import { AdminSidebar } from "./AdminSidebar";

export const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  return (
    <Page
      fullHeight
      navbar={
        <AppNavbar onMenuClick={handleSidebarToggle} />
      }
    >
      <ContentWrapper>
        <Backdrop $isOpen={sidebarOpen} onClick={handleSidebarClose} />
        <SidebarWrapper $isOpen={sidebarOpen}>
          <AdminSidebar onNavigate={handleSidebarClose} />
        </SidebarWrapper>
        <MainContent>
          <Outlet />
        </MainContent>
      </ContentWrapper>
    </Page>
  );
};

